// Gateway switches the backend's change_payment_gateway endpoint allows for a due order.
// India: phonepe <-> razorpay. International: razorpay <-> stripe (stripe is a one-time card payment). Postpaid only.
export const payment_gateway_options = (store_info, order) => {
  if (!store_info || !order || order.type !== 'postpaid') return [];
  // the backend decides by Store.market; country is the fallback when market isn't loaded
  const is_india = store_info.market ? store_info.market === 'india' : store_info.country === 'IN';
  if (is_india) {
    if (order.payment_gateway === 'phonepe') return [{ payment_gateway: 'razorpay', label: 'Change to Razorpay' }];
    if (order.payment_gateway === 'razorpay') return [{ payment_gateway: 'phonepe', label: 'Change to PhonePe' }];
    return [];
  }
  if (order.payment_gateway === 'stripe') return [{ payment_gateway: 'razorpay', label: 'Change to Razorpay (USD)' }];
  if (order.payment_gateway === 'razorpay') return [{ payment_gateway: 'stripe', label: 'Change to Stripe (one-time card payment)' }];
  return [];
};
